@if (this.slideAuthorFacade.currentSelectedSlidePoi$ | async; as poi) {
  <!-- Header -->
  @if (poi) {
    <medsurf-slide-edit-header
      [icon]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.SIGN_POST"
      [label]="poi.name"
    [type]="'global.poi'"></medsurf-slide-edit-header>
  }
  <!-- Content -->
  <div #edit_overlay_template_scroll_panel
    class="flex flex-1 overflow-auto justify-content-center">
    <!-- Accordion -->
    <p-accordion [activeIndex]="[0, 1, 2]"
      [multiple]="true"
      styleClass="no_border"
      class="w-full h-full ml-3 mr-3">
      <p-accordionTab [header]="'global.general' | translate"
        headerStyleClass="uppercase">
        <!-- Poi Form -->
        @if (poiForm) {
          <medsurf-design-form-control-form
            [formGroup]="poiForm"
            [class]="'w-full'"
            (onSubmit)="onSubmit()">
            <div class="flex flex-column row-gap-2 align-items-center">
              <!-- Name -->
              <medsurf-design-form-control-input-text [control]="poiForm.controls.name"
                [label]="'global.name'"
                [class]="'w-full align-self-start'"
                [placeholder]="'global.name'"
              (valueChange)="onSubmit()"></medsurf-design-form-control-input-text>
              <!-- Position -->
              <div class="flex flex-row column-gap-2 align-items-center w-full">
                @if (poi) {
                  <div
                    class="flex flex-grow-1 mr-2">
                    {{ getPoiBoundsString(poi) }}
                  </div>
                }
                <button medsurf-design-input-button [id]="'poi_update_position'"
                  [title]="'global.poi_update_position' | translate"
                  [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.RELOAD"
                (click)="updatePoiPosition(poi)"></button>
                <button medsurf-design-input-button [id]="'poi_go_to'"
                  [title]="'global.poi_go_to' | translate"
                  [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.LOCATE"
                (click)="goToPoi(poi)"></button>
              </div>
            </div>
            <medsurf-editor class="w-full"
              label="global.text"
              placeholder="global.text"
              [control]="poiForm.controls.note"
              [toolbarExcludes]="['mediaimage', 'mediapdf', 'mediaaudio', 'mediavideo', 'marker']"
              (valueChange)="onSubmit()"></medsurf-editor>
          </medsurf-design-form-control-form>
        }
      </p-accordionTab>
      <p-accordionTab [header]="'global.relation' | translate"
        headerStyleClass="uppercase">
        <div class="flex flex-column align-items-center">
          <!-- Images -->
          <medsurf-slide-edit-poi-image-form [class]="'w-full'"></medsurf-slide-edit-poi-image-form>
          <!-- Annotations -->
          <medsurf-slide-edit-poi-annotation-form [class]="'w-full'"></medsurf-slide-edit-poi-annotation-form>
          <!-- Synchronize -->
          <medsurf-design-input-menu [name]="'poi_annotation_synchronize_menu'"
            [label]="'global.images_synchronize'"
            [class]="'w-full align-self-start'"
            [buttonInputClass]="FlatModels.ButtonDesignModels.ButtonDesignClass.PRIMARY_MENU"
            [iconOpen]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.RELOAD"
            [iconClose]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.RELOAD"
          [items]="poiAnnotationSynchronizeMenuItems"></medsurf-design-input-menu>
        </div>
      </p-accordionTab>
    </p-accordion>
  </div>
}
